var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5116 20.4157H5.48859C4.95676 20.4157 4.52563 19.9846 4.52563 19.4527V5.42975C4.52563 4.89793 4.95676 4.4668 5.48859 4.4668H19.5116C20.0434 4.4668 20.4745 4.89793 20.4745 5.42975V19.4527C20.4745 19.9846 20.0434 20.4157 19.5116 20.4157Z",
    stroke: "black",
    strokeWidth: 0.962952
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74121 16.5417L9.33604 12.5619C9.98655 11.9985 10.9529 12.001 11.6005 12.5678L19.828 19.769",
    stroke: "black",
    strokeWidth: 0.962952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6727 8.56269C17.6727 7.8485 17.0938 7.26953 16.3796 7.26953C15.6654 7.26953 15.0864 7.8485 15.0864 8.56269C15.0864 9.27687 15.6654 9.85584 16.3796 9.85584C17.0938 9.85584 17.6727 9.27687 17.6727 8.56269Z",
    stroke: "black",
    strokeWidth: 0.962952
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBtn);
export default __webpack_public_path__ + "static/media/ImgBtn.5f6ad1b211b8e3254bf7ee948981ad0d.svg";
export { ForwardRef as ReactComponent };